import getCategoryDetails from "../../../../../state/modules/category/selectors/getCategoryDetails";
import getCategoryId from "../../../../../state/modules/category/selectors/getCategoryId";
import { getCanonicalPath } from "../../../../../state/modules/router/selectors";

const MIN_VISUAL_CATEGORY_COUNT = 5;
const MAX_VISUAL_CATEGORY_COUNT = 16;
const EMPTY_ARRAY = [];
export const SEE_ALL_TRANSLATION_KEY =
  "plp_curatedcategories_carousel_cta_view_all";

const getVisualCategories = (state) =>
  getCategoryDetails(state)?.visualCategories || EMPTY_ARRAY;

const buildLinkUrl = ({ pathname, categoryId }) => {
  if (!pathname) {
    return "/";
  }

  return categoryId ? `${pathname}?cid=${categoryId}` : pathname;
};

const withCategoryId = ({ linkUrl, categoryId }) => {
  if (!linkUrl) {
    return "/";
  }

  const [pathname, queryString = ""] = linkUrl.split("?");
  const params = new URLSearchParams(queryString);

  if (categoryId) {
    params.set("cid", categoryId);
  } else {
    params.delete("cid");
  }

  const nextQueryString = params.toString();

  return nextQueryString ? `${pathname}?${nextQueryString}` : pathname;
};

const getSeeAllLinkUrl = (state, visualCategories) => {
  const canonicalPath = getCanonicalPath(state) || "/";
  const visualCategoriesRootCategoryId =
    getCategoryDetails(state)?.visualCategoriesRootCategoryId;
  const currentCategoryId = getCategoryId(state);
  const targetCategoryId = visualCategoriesRootCategoryId ?? currentCategoryId;
  const isChildCategoryPage = visualCategories.some(
    (category) => String(category.id) === String(currentCategoryId),
  );

  if (isChildCategoryPage) {
    const breadcrumbs = state.category?.breadcrumbs || EMPTY_ARRAY;
    const parentBreadcrumb = breadcrumbs[breadcrumbs.length - 2];

    if (parentBreadcrumb?.Url) {
      return visualCategoriesRootCategoryId != null
        ? withCategoryId({
            linkUrl: parentBreadcrumb.Url,
            categoryId: visualCategoriesRootCategoryId,
          })
        : parentBreadcrumb.Url;
    }

    if (
      visualCategoriesRootCategoryId != null ||
      parentBreadcrumb?.CategoryId != null
    ) {
      return buildLinkUrl({
        pathname: canonicalPath,
        categoryId:
          visualCategoriesRootCategoryId ?? parentBreadcrumb.CategoryId,
      });
    }
  }

  return buildLinkUrl({
    pathname: canonicalPath,
    categoryId: targetCategoryId,
  });
};

export default (state) => {
  const rawVisualCategories = getVisualCategories(state);

  if (rawVisualCategories.length === 0) {
    return EMPTY_ARRAY;
  }

  const visualCategories = rawVisualCategories.filter(
    (category) => category?.name && category?.imageUrl && category?.linkUrl,
  );

  if (visualCategories.length === 0) {
    return EMPTY_ARRAY;
  }

  const constrainedVisualCategories = visualCategories.slice(
    0,
    MAX_VISUAL_CATEGORY_COUNT - 1,
  );
  const seeAllLinkUrl = getSeeAllLinkUrl(state, visualCategories);

  const visualCategoriesWithSeeAll = [
    {
      id: 0,
      name: SEE_ALL_TRANSLATION_KEY,
      imageUrl: constrainedVisualCategories[0].imageUrl,
      linkUrl: seeAllLinkUrl,
      isSeeAll: true,
    },
    ...constrainedVisualCategories,
  ];

  return visualCategories.length >= MIN_VISUAL_CATEGORY_COUNT
    ? visualCategoriesWithSeeAll
    : EMPTY_ARRAY;
};
